import React from "react";
import "./AboutUs.css";
import companyLogoImg from "./images/photo-1624280433509-b01afeaf68e5.avif";

export const AboutUs = () => {
  return (
    <>
      <div className="bodyContent flex">
        <div className="companyLogoContainer">
          <img
            className="companyLogo"
            src={companyLogoImg}
            alt="company logo"
          />
          <div className="CompanyName">Kai Tsz</div>
        </div>

        <div className="aboutUsContainer">
          <header>About Us</header>
          <div className="description">
            Welcome to Kai Tsz Technology Company, a dynamic and innovative
            startup that is passionate aboutOur mission is to enable individuals
            and organizations worldwide to reach their full potential and
            accomplish their goals through empowerment. We have a common goal:
            to create cutting-edge solutions that solve real-world problems and
            make a positive impact on society.
          </div>

          <div className="description">
            Our journey began 2023, we believe that the key to success is a
            combination of creativity, hard work, and a deep understanding of
            our customers' needs. That's why we work closely with our clients to
            develop customized solutions that meet their unique requirements and
            exceed their expectations.
          </div>

          <div className="description">
            We are proud of our achievements so far, but we know that there is
            always more we can do. That's why we are always looking for new
            challenges and opportunities to grow and improve. Whether you are a
            startup, small business, or a large enterprise, we are here to help
            you achieve your goals and take your business to the next level.
          </div>
        </div>
      </div>
    </>
  );
};
